import { createListReducer } from '../../../common/services/reducerCreator';

// Inline-edited list: sync rows on UPDATE_INJURY_TYPE_FULFILLED so the Valider
// button resets to pristine after a successful save (see createListReducer).
export default createListReducer('INJURY_TYPES', [], undefined, 'INJURY_TYPE');
